"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteConfig = deleteConfig;
exports.getConfigInfo = getConfigInfo;
exports.getConfigPage = getConfigPage;
exports.refreshCache = refreshCache;
exports.saveConfig = saveConfig;
exports.updateConfig = updateConfig;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getConfigPage(query) {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig/page',
    method: 'get',
    params: query
  });
}
function getConfigInfo(id) {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig/info/' + id,
    method: 'get'
  });
}
function saveConfig(data) {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig',
    method: 'post',
    data: data
  });
}
function updateConfig(data) {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig',
    method: 'put',
    data: data
  });
}
function deleteConfig(id) {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig/' + id,
    method: 'delete'
  });
}
function refreshCache() {
  return (0, _requestPIM.default)({
    url: '/rateLimitConfig/refreshCache',
    method: 'post'
  });
}